import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {ComisionesRoutingModule} from './comisiones.routing.module';
import {
  ComisionComponent, LiquidarComisionesComponent,
  ListaComisionesComponent,
  NewComisionesComponent, NewComisionTiendaComponent,
  ViewComisionesComponent
} from './components/comision.component';
import {ComisionServices} from './services/comision.services';
import {DetalleComisionEmpleado} from './components/detalle.comision.empleado';
import {CollapseModule, ModalModule, TypeaheadModule} from 'ngx-bootstrap';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {ComisionesSecurityServices} from './services/comisiones.security.services';
import {ReporteComisionMensual} from './components/reportes/reporte.comision.mensual';
import {ComisionIndividualComponent} from './components/comision.individual.component';

@NgModule({
  declarations:[
    ComisionComponent,
    DetalleComisionEmpleado,
    ListaComisionesComponent,
    NewComisionesComponent,
    ViewComisionesComponent,
    LiquidarComisionesComponent,
    NewComisionTiendaComponent,
    ReporteComisionMensual,
    ComisionIndividualComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    BrowserModule,
    ComisionesRoutingModule,
    CollapseModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    NgxDatatableModule,
    TypeaheadModule
  ],
  providers:[
    ComisionServices,
    ComisionesSecurityServices
  ]
})
export class ComisionesModule {

}
